import { NOTIFICATION_SETTINGS_ASYNC_ACTIONS } from "PFReducers/notification_settings_reducer";
import { useEffect } from "react";

export const useNotificationSettings = (dispatch, store) => {
  const { currentProfile } = store;
  const userLoggedIn = currentProfile.loaded && currentProfile.logged_in;

  useEffect(() => {
    if (userLoggedIn) {
      dispatch({ type: NOTIFICATION_SETTINGS_ASYNC_ACTIONS.NOTIFICATION_SETTINGS_FETCH });
    }
  }, [userLoggedIn]);
};
